import React from 'react'
import styles from './Avatar.module.scss'
import classNames from 'classnames'
type Props = {
  image: string
  width: string
  height: string
  alt: string
  shape?: string
  styleOverride?: string
}

const Avatar = (props: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  const { image, width, height, shape, alt, styleOverride } = props
  return (
    <img
      className={classNames(
        {
          [styles.avatarRound]: shape === 'round',
        },
        'avatar',
        'lazyload',
        styleOverride
      )}
      loading='lazy'
      width={width}
      height={height}
      data-src={image}
      alt={alt}
      itemProp='image'
    />
  )
}

export default Avatar
